import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  distributionDimensionList: undefined,
  distributionLabel: {orderBy: 'count', order: 'dsc', label: 'Count'},
  showPopulationDistribution: false,
  selectedDimension: 'none',
  isInitialized: false
}

const populationDistributionDimensionSlice = createSlice({
  name: 'populationDistributionDimension',
  initialState,
  reducers: {
    setDistributionDimensionList: (state, action) => {
      state.distributionDimensionList = action.payload
    },
    setDistributionLabel: (state, action) => {
      state.distributionLabel = action.payload
    },
    setShowPopulationDistribution: (state, action) => {
      state.showPopulationDistribution = action.payload
    },
    setSelectedDimension: (state, action) => {
      state.selectedDimension = action.payload
    },
    setIsInitialized: (state, action) => {
      state.isInitialized = action.payload
    },
    clearPopulationDistributionDimension: (state) => {
      state.distributionDimensionList = undefined
      state.distributionLabel = {orderBy: 'count', order: 'dsc', label: 'Count'}
      state.showPopulationDistribution = false
      state.selectedDimension = 'none'
    }
  }
})

export const {
  setDistributionDimensionList,
  setDistributionLabel,
  setShowPopulationDistribution,
  setSelectedDimension,
  setIsInitialized,
  clearPopulationDistributionDimension
} = populationDistributionDimensionSlice.actions

export const selectDistributionDimensionList = (state) =>
  state.populationDistributionDimension.distributionDimensionList
export const selectDistributionLabel = (state) => state.populationDistributionDimension.distributionLabel
export const selectShowPopulationDistribution = (state) =>
  state.populationDistributionDimension.showPopulationDistribution
export const selectSelectedDimension = (state) => state.populationDistributionDimension.selectedDimension
export const selectIsPopulationDistributionDimensionInitialized = (state) =>
  state.populationDistributionDimension.isInitialized

export default populationDistributionDimensionSlice.reducer
